module.exports = __webpack_public_path__ + "img/g.8317c743.png";